import { render, staticRenderFns } from "./EsamiLaboratorioViewComponent.vue?vue&type=template&id=13c88f5a"
import script from "./EsamiLaboratorioViewComponent.vue?vue&type=script&lang=js"
export * from "./EsamiLaboratorioViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports